import { Views } from "./views";
import { Spends } from "./spends";

export class EntityStats {
    public views: Views = new Views();
    public spend: Spends = new Spends();
}